import React from 'react';
import Countdown, { CountdownRenderProps } from 'react-countdown';
import { Trans } from 'react-i18next';
import styles from './Timer.module.scss';
import { TranslationKey } from '@/types/i18n.types';

interface ITimerProps {
  dateInMs: number;
  onComplete: () => void;
  text: TranslationKey;
  small?: boolean;
}

const renderer = ({
  hours,
  minutes,
  seconds,
  small,
}: CountdownRenderProps & { small?: boolean }): React.ReactElement => {
  const formatTime = (time: number): string => String(time).padStart(2, '0');

  return (
    <div className={styles.timeDisplay}>
      {[hours, minutes, seconds].map((time, index) => (
        <React.Fragment key={index}>
          <div className={small ? styles.timeBoxSmall : styles.timeBox}>
            <div className={small ? styles.timeTextSmall : styles.timeText}>
              {formatTime(time)}
            </div>
          </div>
          {index < 2 && (
            <div className={small ? styles.colonSmall : styles.colon}>:</div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export const Timer: React.FC<ITimerProps> = ({
  dateInMs,
  onComplete,
  text,
  small,
}) => {
  return (
    <div className={small ? styles.timerContainerSmall : styles.timerContainer}>
      {!small && (
        <div className={styles.timerLabel}>
          <Trans i18nKey={text} />
        </div>
      )}
      <Countdown
        date={dateInMs}
        renderer={(countdownProps: CountdownRenderProps) =>
          renderer({
            ...countdownProps,
            small,
          })
        }
        onComplete={onComplete}
      />
    </div>
  );
};
